import React from "react";
import styled from "styled-components";
import { flexbox, layout, position, space, background, border, color } from "styled-system";
import { FlexProps } from "./types";

const Flex = styled.div<FlexProps>`
  display: flex;
  ${flexbox}
  ${layout}
  ${position}
  ${space}
  ${background}
  ${border}
  ${color}
  ${({ gap }) => gap && `gap: ${gap};`}
`;

export default Flex;
